import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import nl2br from "react-nl2br";
import HowItWorks from "../../components/pages/HowItWorks";

import {
  MESSAGE_CLAIRE,
  WHY_VISIT_ONLINE,
  WHY_VISIT_ONLINE_LAST,
  PAGES
} from "../../constants/constants";

import { gaPageview } from "../../utils/dev";

export default class HowItWorksPage extends Component {
  componentDidMount() {
    const thisPage = PAGES["how-it-works"];
    document.title = thisPage.title;

    window.scroll({ top: 0, left: 0, behavior: "smooth" });
    gaPageview(this.props.location);
  }
  render() {
    const mapWhyOnline = WHY_VISIT_ONLINE.map((whyVisit, index) => {
      return (
        <div className="col-sm-6" key={`visit-online-${index}`}>
          <div className="why-content">
            <img
              src={`/images/why-visit-vet/${whyVisit.image}`}
              alt={whyVisit.image}
            />
            <p>{whyVisit.text}</p>
          </div>
        </div>
      );
    });

    const mapWhyOnlineLast = WHY_VISIT_ONLINE_LAST.map((whyVisit, index) => {
      return (
        <div className="col-sm-4" key={`visit-online-last-${index}`}>
          <div className="why-content">
            <img
              src={`/images/why-visit-vet/${whyVisit.image}`}
              alt={whyVisit.image}
            />
            <h3>{whyVisit.title}</h3>
            <p>{whyVisit.text}</p>
          </div>
        </div>
      );
    });

    return (
      <Fragment>
        <HowItWorks />
        <div className="container why-visit-vet-online">
          <div className="row">
            <div className="col-sm-12 section-title">
              <Link to="/pricing" className="btn btn-vetchat">
                Start Chatting
              </Link>
              <h2>Why visit the Vet online?</h2>
            </div>
            {mapWhyOnline}
          </div>
        </div>
        <div className="container-fluid message-claire">
          <div className="row">
            <div className="col-sm-6 claire-msg-image">
              <img
                src={`/images/${MESSAGE_CLAIRE.image}`}
                alt="claire jenkins with hre pet"
              />
            </div>
            <div className="col-sm-6 message-quick-chat">
              <div className="">
                <h3>{MESSAGE_CLAIRE.title}</h3>
                <p>{nl2br(MESSAGE_CLAIRE.message)}</p>
                <p className="text-right">- Dr Claire</p>
              </div>
            </div>
          </div>
        </div>
        <div className="container why-visit-vet-online-last">
          <div className="row">{mapWhyOnlineLast}</div>
        </div>
      </Fragment>
    );
  }
}
